/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmploymentConditionLibraryEmployeesReplaceEmployeeModel {
  targetEmployeeId: string;
  deleteSourceEmployee?: boolean;
  module?: EmploymentConditionLibraryEmployeesReplaceEmployeeModelModuleEnum | null;
}
export enum EmploymentConditionLibraryEmployeesReplaceEmployeeModelModuleEnum {
  Default = 'Default',
  Restructuring = 'Restructuring',
  Playground = 'Playground'
}
